import { notification } from "antd";

export function notifyClientONExistingAppointment() {
  const key = `existing-apt-${Date.now()}`;
  notification.warning({
    message: "Patient already has an appointment today",
    description: "New booking skipped due to your appointment config",
    placement: "topRight",
    duration: 6,
    btn: (
      <button
        onClick={() => {
          window.location.href = "/app/settings/appointment-configs";
          notification.close(key);
        }}
        style={{
          backgroundColor: "#215FFF",
          color: "#fff",
          border: "none",
          borderRadius: "8px",
          padding: "6px 16px",
          fontSize: "13px",
          fontWeight: 500,
          cursor: "pointer",
          width: "100%",
        }}
      >
        View Config
      </button>
    ),
    key,
  });
}
